export const GUIDE_HEIGHT = 88;
export const TITLE_WIDTH = 100;
export const TITLE_HEIGHT = 13;
export const PURCHASED_AMOUNT = 3;
export const FREE_AMOUNT = 5;
